export default "__VITE_ASSET__Dr9M8R6D__"